import { render, staticRenderFns } from "./Patients.vue?vue&type=template&id=7ff6b4bc"
import script from "./Patients.vue?vue&type=script&lang=ts"
export * from "./Patients.vue?vue&type=script&lang=ts"
import style0 from "./Patients.vue?vue&type=style&index=0&id=7ff6b4bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports